<template>
  <div class="date-box-wrap" >
    <div class="date-content-box" @click.stop="showDateList">
      <slot :date="chosenDate">
        <div class="date-input-wrap">
          <div class="date-box-input">
            <div v-if="chosenDate">{{chosenDate | dateNamify}}</div>
            <div class="input-placeholder" v-else>请选择生效日期</div>
          </div>
        </div>
      </slot>
    </div>

    <div class="date-box-list"   v-show="shouldDateListShow" >
      <div class="date-list-title">
        <img class="arrow-left" @click.stop="toggleMonth(0)" src="https://o.666visa.cn/static/ssqpeer/order/icon-right-blue.png" alt="">
        <div class="title-value">
          <div class="month-box">{{nowMonth}}<span>月</span></div>
          <div class="year-box"><span>/</span>{{nowYear}}年</div>
        </div>
        <img class="arrow-right" @click.stop="toggleMonth(1)" src="https://o.666visa.cn/static/ssqpeer/order/icon-right-blue.png" alt="">
      </div>

      <div class="date-list-week">
        <span v-for="week in weekdayForShort" :key="week">{{week}}</span>
      </div>

      <div class="date-list-day">
        <div class="month-bg">{{nowMonth}}</div>
        <div class="date-day-item" v-for="(n,index) in nowMonthArr" :key="index"
          :style="{marginLeft: index === 0 ? beginDay*54+'px' : ''}"
          :class="{'chosenDay':nowYear === chosenYear&& nowMonth === chosenMonth&&(index+1)===chosenDay,'disabled': isTodayDisabled(index)}"
          @click="choosedate(index+1, isTodayDisabled(index))">
          <div class="day-item-bg"></div>
          <div class="date-day-day">
            {{nowYear === todayYear&& nowMonth === todayMonth&&index + 1 === todayDate?'今天':index+1}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dateUtils from '../libs/date-util';

export default {
  props: ['selectDate', 'minDisabledDate'],
  data() {
    return {
      shouldDateListShow: false,
      weekday: { 0: '星期日', 1: '星期一', 2: '星期二', 3: '星期三', 4: '星期四', 5: '星期五', 6: '星期六' },
      weekdayForShort: { 0: '日', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六' },

      beginDay: 0, // 每个月开始第一天星期几
      nowYear: '', // 控件当前显示的日期
      nowMonth: '',
      nowDate: '',
      nowMonthArr: [], // 控件当前显示的月份数组

      todayYear: new Date().getFullYear(), // 今天的日期
      todayMonth: new Date().getMonth() + 1,
      todayDate: new Date().getDate(),

      chosenDate: '', // 选择的日期
      chosenYear: '',
      chosenMonth: '',
      chosenDay: '',

      disabledDate: new Date(), // 禁止选择的日期
      disabledYear: '',
      disabledMonth: '',
      disabledDay: '',
    };
  },
  computed: {
  },
  created() {
    this.handleData();
  },
  mounted() {
    document.addEventListener('click', this.handleClick, true);
  },
  destroyed() {
    document.removeEventListener('click', this.handleClick, true);
  },

  watch: {
    selectDate() {
      this.handleData();
    },
    minDisabledDate(val) {
      if (val) {
        this.handleData();
      }
    },
  },
  filters: {
    dateNamify(dateStr) {
      if (!dateStr) return '';
      return dateUtils.formatDateWithzeroWithWeek(dateStr);
    },
  },
  methods: {
    handleClick(e) {
      if (!this.$el.contains(e.target) && !this.forShow) {
        this.shouldDateListShow = false;
      }
    },
    // 初始化一些设置
    handleData() {
      // 设置传入的默认的选择日期
      if (this.selectDate) {
        const chosenDate = new Date(this.selectDate);
        this.chosenYear = chosenDate.getFullYear();
        this.chosenMonth = chosenDate.getMonth() + 1;
        this.chosenDay = chosenDate.getDate();
        const newMonth = this.chosenMonth < 10 ? (`0${this.chosenMonth}`) : this.chosenMonth;
        const newDay = this.chosenDay < 10 ? (`0${this.chosenDay}`) : this.chosenDay;
        this.chosenDate = `${this.chosenYear}-${newMonth}-${newDay}`;
      } else {
        this.chosenDate = '';
        this.chosenYear = '';
        this.chosenMonth = '';
        this.chosenDay = '';
      }

      // 设置禁止选择的日期
      if (this.minDisabledDate) {
        this.disabledDate = new Date(this.minDisabledDate);
      }
      this.disabledYear = new Date(this.disabledDate).getFullYear();
      this.disabledMonth = new Date(this.disabledDate).getMonth() + 1;
      this.disabledDay = new Date(this.disabledDate).getDate();

      this.setMonthAndYear(this.chosenDate || this.disabledDate);
    },

    // 设置当前月份，年份，天数
    setMonthAndYear(defaultDate) {
      let date = '';
      if (!defaultDate) {
        date = new Date();
      } else {
        date = new Date(defaultDate);
      }
      date.setDate(1);
      this.beginDay = date.getDay();
      this.nowYear = date.getFullYear();
      this.nowMonth = date.getMonth() + 1;
      this.nowDate = date.getDate();

      const newArrLength = new Date(this.nowYear, this.nowMonth, 0).getDate();
      const newArr = [];
      let i = 0;
      while (i < newArrLength) {
        newArr.push({ show: false, showText: '' });
        i++;
      }

      this.nowMonthArr = newArr;
    },
    // 切换月份，0减少月份，1增加月份
    toggleMonth(direction) {
      if (this.nowYear > this.todayYear + 30 || this.nowYear < this.todayYear - 30) {
        return;
      }

      if (this.nowMonth === 12 && direction === 1) {
        this.nowYear = this.nowYear + 1;
        this.nowMonth = 1;
      } else if (this.nowMonth === 1 && direction === 0) {
        this.nowYear = this.nowYear - 1;
        this.nowMonth = 12;
      } else if (direction === 1) {
        this.nowMonth = this.nowMonth + 1;
      } else if (direction === 0) {
        this.nowMonth = this.nowMonth - 1;
      }
      this.nowMonth = this.nowMonth < 10 ? `0${this.nowMonth}` : this.nowMonth;

      this.setMonthAndYear(`${this.nowYear}-${this.nowMonth}`);
      this.shouldDateListShow = true;
    },
    // 选择日期
    choosedate(day, disabled) {
      let chosenDateString = '';

      const newMonth = this.nowMonth < 10 ? (`0${this.nowMonth}`) : this.nowMonth;
      const newDay = day < 10 ? (`0${day}`) : day;

      chosenDateString = `${this.nowYear}-${newMonth}-${newDay}`;
      // const currentTime = new Date(chosenDateString).getTime();

      if (disabled) return;

      this.chosenYear = this.nowYear;
      this.chosenMonth = this.nowMonth;
      this.chosenDay = day;

      this.chosenDate = chosenDateString;

      this.shouldDateListShow = false;

      this.$emit('input', new Date(this.chosenDate));
    },
    isTodayDisabled(day) {
      day = day + 1 < 10 ? `0${day + 1}` : day + 1;
      const month = this.nowMonth < 10 ? `0${this.nowMonth}` : this.nowMonth;
      const currentDateStr = `${this.nowYear}-${month}-${day}`;
      const currentTime = new Date(currentDateStr).getTime();
      if (this.selectDate === currentDateStr) return false;
      if (this.disabledDate.getTime() >= currentTime) {
        return true;
      }
    },
    showDateList() {
      this.shouldDateListShow = !this.shouldDateListShow;
    },
  },

};
</script>

<style lang="less" scoped>
@import '../assets/less/variable';
.date-box-wrap{
  position: relative;
  display: inline-flex;
  width: 100%;
  .date-content-box{
    width: 100%;
    display: inline-flex;
  }
}
  .date-input-wrap {
    width: 100%;
    height: 40px;
    border: 1px solid #dddddd;
    line-height: 38px;
    font-size: 14px;
    border-radius: 4px;
    position: relative;
    background-color: #fff;
    cursor: pointer;
    .date-box-input {
      display: flex;
      position: relative;
      align-items: center;
      color: #2F333D;
      padding: 0 24px 0 10px;
      &::after {
        content: '';
        width: 18px;
        height: 18px;
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        background: url(https://o.666visa.cn/static/ssqpeer/order/calendar-icon.png) no-repeat center / 100% 100%;
      }
      .input-placeholder {
        color: #91999F;
      }
    }


  }
  .date-box-list {
    position: absolute;
    width: 414px;
    background-color: #ffffff;
    border-radius: 4px;
    z-index: 99;
    top: 100%;
    margin-top: 18px;
    left: 50%;
    transform: translateX(-50%);
    box-shadow:0px 10px 30px 0px rgba(131,146,167,0.2);
    border:1px solid rgba(233,238,242,1);
    line-height: 1;
    &::after{
      content: "";
      width: 15px;
      height: 15px;
      background: #E9EEF2;
      position: absolute;
      left: 50%;
      top: -9px;
      transform: rotate(45deg);
      z-index: 1;
    }
    &::before{
      content: "";
      width: 15px;
      height: 15px;
      background: #fff;
      position: absolute;
      left: 50%;
      top: -8px;
      transform: rotate(45deg);
      z-index: 2;
    }

    .date-list-title {
      position: relative;
      z-index: 3;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      .arrow-left{
        width: 12px;
        height: 12px;
        transform: rotate(180deg);
        cursor: pointer;
      }
      .title-value{
        margin: 0 12px;
        display: flex;
        align-items: center;
        .month-box{
          display: flex;
          align-items: center;
          color: #2F333D;
          font-size: 20px;
          font-weight: 600;
          span{
            margin-left: 2px;
            font-size: 12px;
            font-weight: 400;
            margin-top: 2px;
          }
        }
        .year-box{
          margin-left: 2px;
          color: #91999F;
          font-size: 14px;
          margin-top: 2px;
          span{
            margin-right: 2px;
          }
        }
      }

      .arrow-right{
        cursor: pointer;
        width: 12px;
        height: 12px;
      }
    }

    .date-list-week {
      background-color: #F5F7F9;
      height: 28px;
      font-size: 14px;
      color: #5F666E;
      display: flex;
      align-items: center;
      padding-left: 20px;
      span {
        width: 50px;
        margin-right: 4px;
        text-align: center;
        &:last-child{
          margin-right: 0;
          color: #FF5966;
        }
        &:first-child{
          color: #FF5966;
        }
      }
    }

    .date-list-day {
      padding-top: 16px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding-left: 20px;
      position: relative;
      z-index: 1;
      .month-bg{
        position: absolute;
        z-index: -1;
        font-size: 200px;
        color: #F3F6F9;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        user-select: none;
      }
      .date-day-item {
        width: 50px;
        height: 40px;
        margin-bottom: 4px;
        margin-right: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 6px;
        color: #2F333D;
        cursor: pointer;
        border-radius:2px;
        position: relative;
        .day-item-bg{
          position: absolute;
          z-index: 1;
          left: 0;
          top: -6px;
          border-radius:2px;
          width: 100%;
          height: 100%;
        }
        .date-day-day {
          position: relative;
          z-index: 3;
          font-size: 16px;
          font-weight: 600;
        }
        .date-day-icon{
          position: relative;
          z-index: 3;
          margin-top: 3px;
          font-size: 12px;
          &.is-weekend {
            color: #599FFF;
          }
          &.is-holiday {
            color: #FF6464;
          }
        }
        &.disabled {
          cursor: not-allowed;
          color: #C9CDD1;
          .date-day-day{
            font-weight: 400;
          }
        }
        &.chosenDay{
          color: #fff;
          &.have-holiday .day-item-bg{
            top: 0;
          }
          .day-item-bg{
            background:linear-gradient(135deg,rgba(79,153,255,1) 0%,rgba(31,124,255,1) 100%);
            &::after{
              content: "";
              position: absolute;
              bottom: -1px;
              left: 50%;
              transform: translateX(-50%);
              z-index: 1;
              background: #599FFF;
              filter:blur(4px);
              width:39px;
              height:4px;
            }
          }
        }
      }
    }

    .date-list-subtitle {
      padding: 12px 20px;
      background: #F5F7F9;
      .subtitle-box{
        display: flex;
        align-items: center;
        .subtitle-item{
          display: flex;
          align-items: center;
          margin-right: 20px;
          .item-label{
            height: 16px;
            padding: 0 3px;
            border-radius: 8px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            margin-right: 4px;
          }
          .item-value{
            color: #5F666E;
            font-size: 12px;
          }
          &.weekend .item-label{
            color: #599FFF;
          }
          &.holiday .item-label{
            color: #FF5966;
          }
          &.early .item-label{
            color: #91999F;
          }
        }
      }
      .tips{
        margin-top: 6px;
        color: #5F666E;
        font-size: 12px;
        display: flex;
        align-items: center;
        .icon{
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/insurance-date-picker.vue